import React, {  } from "react";
import '@esri/calcite-components/dist/calcite/calcite.css';
import "./App.css";
import Map from "./components/Map/Map";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import config from "./assets/config.json";


function App() {
  const routeArray: Array<any> = [];
  for (let extension in config.layerExtensions) {
    const info = config.layerExtensions[extension];
    routeArray.push(<Route key={extension} path={info.url} element={<Map extensionData={{ type: info.type, layer: info.layer }} />} />);
  }
  for (let extension in config.siteExtensions) {
    const info = config.siteExtensions[extension];
    routeArray.push(<Route key={extension} path={info.url} element={<Map extensionData={{ type: info.type, where: info.where, siteType: info.siteType }} />} />);
  }
  for (let extension in config.stateExtensions) {
    const info = config.stateExtensions[extension];
    routeArray.push(<Route key={extension} path={info.url} element={<Map extensionData={{ type: 'state', abbr: info.abbr }} />} />);
  }

  // create routes that will use specific site points
  const pathname: string = window.location.pathname;
  let extensionData: Object;

  // get the base URL for the routing
  const getBasename = (path: any) => path.substr(0, path.lastIndexOf('/'));
    if (pathname.includes('/specific&params=')) {
    //superfund sites need layers toggled, popup displayed, and everything else filtered out
    const info: string = pathname.split('/specific&params=')[1];
    const attribute: string = info.split('=')[0];
    const property: string = info.includes('%20') || info.includes(' ') ?
    info.split('=')[1].replaceAll('%20', ' ') :
    info.split('=')[1];
    extensionData = {
      type: 'specific',
      attribute: attribute,
      property: property
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/specific&params=${info}`} element={<Map extensionData={extensionData} />} />);
    // routeArray.push(<Route key = {extensionData['type']} path={`/specific&params=${info}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/superfundZoom&params=')) {
    const pathParams: string = pathname.split('/superfundZoom&params=')[1];
    const SF_SITE_ID: string = pathParams.split('&')[0];
    const zoomLevel: string = pathParams.split('&')[1];
    extensionData = {
      type: 'superfundZoom',
      SF_SITE_ID: SF_SITE_ID,
      zoomLevel: zoomLevel
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/superfundZoom&params=${pathParams}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/bfJurisdiction&params=')) {
    // will be used to search by JURISDICTION_ID or JURISDICTION_NAME
    const info: string = pathname.split('/bfJurisdiction&params=')[1];
    const attribute: string = info.split('=')[0];
    const property: string = info.split('=')[1].replaceAll('%20', ' ');
    extensionData = {
      type: 'bfJurisdiction',
      attribute: attribute,
      property: property
    };
    routeArray.push(<Route key = {extensionData['type']} path={`/bfJurisdiction&params=${info.replaceAll('%20', ' ')}`} element={<Map extensionData={extensionData} />} />);
    // routeArray.push(<Route key = {extensionData['type']} path={`/bfJurisdiction&params=${info}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/ustSpecific&params=')) {
    const info: string = pathname.split('/ustSpecific&params=')[1];
    const attribute: string = info.split('=')[0];
    const property: string = info.includes('%20') || info.includes(' ') ?
    info.split('=')[1].replaceAll('%20', ' ') :
    info.split('=')[1];
    extensionData = {
      type: 'ustSpecific',
      attribute: attribute,
      property: property
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/ustSpecific&params=${info}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/latLong&params=')) {
    const info: string = pathname.split('/latLong&params=')[1];
    const latLong: string = info.split('=')[0];
    const lat = latLong.split(',')[0];
    const long = latLong.split(',')[1];
    extensionData = {
      type: 'latLong',
      attribute: 'latLong',
      property: {lat: lat, long: long}
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/latLong&params=${info}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/grantId&params=')) {
    const info: string = pathname.split('/grantId&params=')[1];
    const grantId: string = info.split('=')[0];
    extensionData = {
      type: 'grantId',
      attribute: 'grantId',
      property: {grantId: grantId}
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/grantId&params=${info}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/zip&params=')) {
    const info: string = pathname.split('/zip&params=')[1];
    const zipCode: string = info.split('=')[0];
    extensionData = {
      type: 'zip',
      zip: zipCode
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/zip&params=${info}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/region&params=')) {
    const info: string = pathname.split('/region&params=')[1];
    const region: string = info.split('=')[0];
    extensionData = {
      type: 'region',
      region: region
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/region&params=${info}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/countyState&params=')) {
    const info: string = pathname.split('/countyState&params=')[1];
    const countyState: string = info.split('=')[0];
    const county: string = decodeURIComponent(countyState.split(',')[0]);
    const state: string = countyState.split(',')[1];
    console.log('County/State: ', county, state);
    console.log(`/countyState&params=${info}`);
    extensionData = {
      type: 'countyState',
      state: state,
      county: county,
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/countyState&params=${info}`} element={<Map extensionData={extensionData} />} />);
  } else if (pathname.includes('/cityState&params=')) {
    const info: string = pathname.split('/cityState&params=')[1];
    const cityState: string = info.split('=')[0];
    const city: string = decodeURIComponent(cityState.split(',')[0]);
    const state: string = cityState.split(',')[1];
    console.log('City/State: ', city, state);
    extensionData = {
      type: 'cityState',
      state: state,
      city: city,
    }
    routeArray.push(<Route key = {extensionData['type']} path={`/cityState&params=${info}`} element={<Map extensionData={extensionData} />} />);
  }

  return (
    <BrowserRouter basename={getBasename(window.location.pathname)}>
      <Routes>
        <Route path='/cimc/' element={<Map isGenericRoute = {true}/>} />
        <Route path='/' element={<Map isGenericRoute = {true}/>} />
        <Route path='*' element={<Map isBadRoute = {true}/>} />
        {routeArray}
      </Routes>
    </BrowserRouter>
  );
};

export default App;